import Divider from '@mui/material/Divider';
import type { SxProps, Theme } from '@mui/material/styles';
import { alpha, styled } from '@mui/material/styles';

const dividerRuleColor = (theme: Theme) => alpha(theme.palette.common.black, 0.3);

export const dividerLabeledAccentSx: SxProps<Theme> = {
  color: (theme: Theme) => theme.palette.primary.dark,
  fontSize: 16,
  fontWeight: 600,
  lineHeight: 1.2,
  '& .MuiDivider-wrapper': {
    px: '10px',
  },
  '&::before, &::after': {
    borderColor: dividerRuleColor,
    borderTopWidth: 1,
  },
};

export const StyledDivider = styled(Divider)(({ theme }) => ({
  color: theme.palette.text.secondary,
  '&::before, &::after': {
    borderColor: dividerRuleColor(theme),
  },
}));
